const Config = {
  app:{
    webaname:'MITRA PENGADAAN',
    company:'MITRA PENGADAAN',
    copyright:()=>{
      let date = new Date()
      if(date.getFullYear()>2024){
        return '2024-'+date.getFullYear()
      }else{
        return '2024'
      }
    }
  },
  encrypt_key: "#@MTRPNGDN2023!!",
  mr:{
    StatusOptions: [
      { text: 'Active', value: 'Y' },
      { text: 'Inactive', value: 'N' },
    ],
    AbleOptions: [
      { text: 'Enable', value: 'Y' },
      { text: 'Disable', value: 'N' },
    ],
    mrCatType:[
      // { text: 'All', value: 'All' },
      { text: 'Article', value: 'ARTICLE' },
      { text: 'News', value: 'NEWS' },
    ]
  },
  wording:{
    detectUpdate: 'Perubahan data belum di simpan.'
  },
  toolsBasicCK: [
    'heading',
    '|',
    'bold',
    'italic',
    'underline',
    'strikethrough',
    'link',
    'bulletedList',
    'numberedList',
    '|',
    'undo',
    'redo'
  ],
  dataShownOptions: [
    { text: '10', value: 10 },
    { text: '20', value: 20 },
    { text: '30', value: 30 },
  ],
  dataShown:10
}
export default Config